import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  MenuItem,
  Grid,
  DialogContentText,
  Button,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import ContainerWithTitle from '../../containers/HOC/ContainerWithTitle'
import { EditableSelect, EditableInput } from '../common/EditableComponents'
import { status, productTypes, archivedOption } from '../../utils/common'
import TextError from './TextError'
import { bulkUpdateChildProducts, updateMasterProducts } from '../../actions/masterCatalog'

const CHILD_SOURCE = 'CHILD'
let timeout
class ModalUpdateMasterProduct extends Component {
  constructor(props) {
    super(props)

    this.state = {
      scroll: 'paper',
      active: null,
      productType: null,
      unitPrice: null,
      archived: null,
      showInWidget: null,
      vendorId: null,
      enableWeedmap: null,
      enableMixMatch: null,
      wmThreshold: null,
      salesPrice: null,
      lowThreshold: null,
      wmOnlineSellable: null,
      error: false,
      message: '',
    }
  }

  componentDidMount() {}

  handleChange = (state, value) => {
    this.setState({
      [state]: value.target.value,
    })
  }

  beforeUpdateProduct = () => {
    const { optionToBulkUpdate, masterProducts } = this.props
    if (this.state[optionToBulkUpdate.field] != null) {
      const product = masterProducts[0]
      if (product.children) {
        this.updateMasterProduct()
      } else {
        this.updateChildProducts()
      }
    } else {
      this.setState({
        error: true,
        message: 'El campo es requerido',
      })
    }
  }

  updateMasterProduct = () => {
    const { optionToBulkUpdate, masterProducts } = this.props
    const data = {
      masterIds: masterProducts.map((c) => c.id),
      operationType: optionToBulkUpdate.action,
      [optionToBulkUpdate.field]: this.state[optionToBulkUpdate.field],
    }

    this.props.dispatch(updateMasterProducts(data)).then(() => {
      timeout = setTimeout(() => {
        this.closeModal(true)
        clearTimeout(timeout)
      }, 2000)
    })
  }

  updateChildProducts = () => {
    const { optionToBulkUpdate, masterProducts } = this.props
    const bulkUpdate = this.getParamsToUpdateChildProduct()
    let value = this.state[optionToBulkUpdate.field]
    if (optionToBulkUpdate.field == 'archived') {
      value = this.state[optionToBulkUpdate.field] ? 'Archived' : 'Unarchive'
    } else if (optionToBulkUpdate.field == 'active') {
      value = this.state[optionToBulkUpdate.field] ? 'Active' : 'Inactive'
    }
    
    const data = {
      childProductIds: masterProducts.map((cp) => cp.id),
      bulkType: bulkUpdate.ACTION,
      [bulkUpdate.FIELD]: value,
      sourceMap: {
        [optionToBulkUpdate.field]: CHILD_SOURCE,
      },
      updateSourceMap: false,
      partialUpdateSourceMap: true
    }
    this.props.dispatch(bulkUpdateChildProducts(data)).then(() => {
      timeout = setTimeout(() => {
        this.closeModal(true)
        clearTimeout(timeout)
      }, 2000)
    })
  }

  getParamsToUpdateChildProduct = () => {
    const { optionToBulkUpdate } = this.props
    let blukUpdate = {}
    switch (optionToBulkUpdate.field) {
      case 'archived':
        blukUpdate = {
          FIELD: 'enableArchive',
          ACTION: 'ARCHIVED',
        }
        break
      case 'active':
        blukUpdate = {
          FIELD: 'enableStatus',
          ACTION: 'STATUS',
        }
        break
      case 'unitPrice':
        blukUpdate = {
          FIELD: 'unitPrice',
          ACTION: 'RETAIL_PRICE',
        }
        break
      case 'productType':
        blukUpdate = {
          FIELD: 'productType',
          ACTION: 'PRODUCT_TYPE',
        }
        break
      case 'showInWidget':
        blukUpdate = {
          FIELD: 'onlineWidget',
          ACTION: 'ONLINE_WIDGET',
        }
        break
      case 'vendorId':
        blukUpdate = {
          FIELD: 'vendorId',
          ACTION: 'VENDOR',
        }
        break
      case 'enableWeedmap':
        blukUpdate = {
          FIELD: 'enableWeedmap',
          ACTION: 'THIRD_PARTY_MENU',
        }
        break
      case 'enableMixMatch':
        blukUpdate = {
          FIELD: 'enableMixMatch',
          ACTION: 'SAME_PRICE_MIX_MATCH',
        }
        break
      case 'wmThreshold':
        blukUpdate = {
          FIELD: 'wmThreshold',
          ACTION: 'WM_INVENTORY_THRESHOLD',
        }
        break
      case 'salesPrice':
        blukUpdate = {
          FIELD: 'wholesalePrice',
          ACTION: 'WHOLESALE_PRICE',
        }
        break
      case 'lowThreshold':
        blukUpdate = {
          FIELD: 'lit',
          ACTION: 'LOW_INVENTORY_THRESHOLD',
        }
        break
      case 'wmOnlineSellable':
        blukUpdate = {
          FIELD: 'wmOnlineSellable',
          ACTION: 'ONLINE_SELLABLE',
        }
        break
      default:
        break
    }
    return blukUpdate
  }

  getComponentToUpdate = (options) => {
    const { masterCatalogReducer } = this.props
    const {
      active,
      productType,
      unitPrice,
      archived,
      showInWidget,
      vendorId,
      enableWeedmap,
      enableMixMatch,
      wmThreshold,
      salesPrice,
      lowThreshold,
      wmOnlineSellable,
    } = this.state
    switch (options.field) {
      case 'active':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">New Status</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableSelect
                name="active"
                editMode={true}
                material={false}
                value={active}
                onChange={(value) => this.handleChange('active', value)}
                valueToRender={active}
              >
                {status.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </Grid>
          </Grid>
        )
      case 'productType':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Product Type</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableSelect
                editMode={true}
                material={false}
                name="productType"
                value={productType}
                onChange={(value) => this.handleChange('productType', value)}
                valueToRender={productType}
              >
                {productTypes.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </Grid>
          </Grid>
        )
      case 'unitPrice':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Retail Value</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableInput
                name="unitPrice"
                placeholder={'Enter Retail Value'}
                editMode={true}
                material={false}
                type="number"
                value={unitPrice}
                onChange={(value) => this.handleChange('unitPrice', value)}
                valueToRender={unitPrice}
              />
            </Grid>
          </Grid>
        )
      case 'archived':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Archived</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableSelect
                name="archived"
                editMode={true}
                material={false}
                value={archived}
                onChange={(value) => this.handleChange('archived', value)}
                valueToRender={archived}
              >
                {archivedOption.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </Grid>
          </Grid>
        )
      case 'showInWidget':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Show Online Widget</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableSelect
                name="showInWidget"
                editMode={true}
                material={false}
                value={showInWidget}
                onChange={(value) => this.handleChange('showInWidget', value)}
                valueToRender={showInWidget}
              >
                {status.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </Grid>
          </Grid>
        )
      case 'vendorId':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Vendor</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableSelect
                name="vendorId"
                editMode={true}
                material={false}
                value={vendorId}
                onChange={(value) => this.handleChange('vendorId', value)}
                valueToRender={vendorId}
              >
                {masterCatalogReducer &&
                  masterCatalogReducer.vendors.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
              </EditableSelect>
            </Grid>
          </Grid>
        )
      case 'enableWeedmap':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">3rd Party Menu</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableSelect
                name="enableWeedmap"
                editMode={true}
                material={false}
                value={enableWeedmap}
                onChange={(value) => this.handleChange('enableWeedmap', value)}
                valueToRender={enableWeedmap}
              >
                {status.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </Grid>
          </Grid>
        )
      case 'enableMixMatch':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Same Price Mix & Match</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableSelect
                name="enableMixMatch"
                editMode={true}
                material={false}
                value={enableMixMatch}
                onChange={(value) => this.handleChange('enableMixMatch', value)}
                valueToRender={enableMixMatch}
              >
                {status.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </Grid>
          </Grid>
        )
      case 'wmThreshold':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Weedmaps Inventory Threshold</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableInput
                name="wmThreshold"
                placeholder={'Enter Value'}
                editMode={true}
                material={false}
                type="number"
                value={wmThreshold}
                onChange={(value) => this.handleChange('wmThreshold', value)}
                valueToRender={wmThreshold}
              />
            </Grid>
          </Grid>
        )
      case 'salesPrice':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Wholesale Price</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableInput
                name="salesPrice"
                placeholder={'Enter Value'}
                editMode={true}
                material={false}
                type="number"
                value={salesPrice}
                onChange={(value) => this.handleChange('salesPrice', value)}
                valueToRender={salesPrice}
              />
            </Grid>
          </Grid>
        )
      case 'lowThreshold':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">Low Threshold</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableInput
                name="lowThreshold"
                placeholder={'Enter Value'}
                editMode={true}
                material={false}
                type="number"
                value={lowThreshold}
                onChange={(value) => this.handleChange('lowThreshold', value)}
                valueToRender={lowThreshold}
              />
            </Grid>
          </Grid>
        )
      case 'wmOnlineSellable':
        return (
          <Grid container className="center-aligned-child">
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              <label className="label-modal">WM Online Sellable</label>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <EditableSelect
                name="wmOnlineSellable"
                editMode={true}
                material={false}
                value={wmOnlineSellable}
                onChange={(value) => this.handleChange('wmOnlineSellable', value)}
                valueToRender={wmOnlineSellable}
              >
                {status.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  )
                })}
              </EditableSelect>
            </Grid>
          </Grid>
        )
      default:
        break
    }
  }

  closeModal = (update = false) => {
    this.setState({
      error: false,
      active: null,
      productType: null,
      unitPrice: null,
      archived: null,
      showInWidget: null,
      vendorId: null,
      enableWeedmap: null,
      enableMixMatch: null,
      wmThreshold: null,
      lowThreshold: null,
      wmOnlineSellable: null,
      salesPrice: null,
    })
    this.props.handleClose(update)
  }

  renderValue = (row) => {
    const { optionToBulkUpdate, masterCatalogReducer = {} } = this.props
    let value = ''
    switch (optionToBulkUpdate.field) {
      case 'active':
        value = row[optionToBulkUpdate.field] ? 'Active' : 'Inactive'
        break
      case 'archived':
        value = row[optionToBulkUpdate.field] ? 'Yes' : 'No'
        break
      case 'showInWidget':
        value = row[optionToBulkUpdate.field] ? 'Active' : 'Inactive'
        break
      case 'vendorId':
        const nameVendor =
          masterCatalogReducer &&
          masterCatalogReducer.vendors &&
          masterCatalogReducer.vendors.find((vendor) => vendor.id === row[optionToBulkUpdate.field])
        value = row[optionToBulkUpdate.field] ? nameVendor && nameVendor.name : ''
        break
      case 'enableWeedmap':
        value = row[optionToBulkUpdate.field] ? 'Active' : 'Inactive'
        break
      case 'enableMixMatch':
        value = row[optionToBulkUpdate.field] ? 'Active' : 'Inactive'
        break
      case 'wmOnlineSellable':
        value = row[optionToBulkUpdate.field] ? 'Active' : 'Inactive'
        break
      default:
        value = row[optionToBulkUpdate.field]
        break
    }
    return value
  }

  render() {
    const { open, handleClose, masterProducts, optionToBulkUpdate } = this.props
    const { scroll, error, message } = this.state
    const product = masterProducts[0] || []
    return (
      <div>
        {masterProducts.length > 0 ? (
          <Dialog
            open={open}
            onClose={handleClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
          >
            <DialogTitle id="scroll-dialog-title">Bulk Update</DialogTitle>
            <DialogContent>
              {optionToBulkUpdate && (
                <React.Fragment>
                  <div className="container-field-update-master-product padding-small">
                    {this.getComponentToUpdate(optionToBulkUpdate)}
                    <TextError error={error} message={message} />
                  </div>
                  <Paper className="container-table">
                    <Table>
                      <TableHead className="table-header">
                        <TableRow>
                          {!product.children ? <TableCell>Shop</TableCell> : null}
                          <TableCell>Product Name</TableCell>
                          <TableCell>{optionToBulkUpdate.name}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {masterProducts.map((row, index) => {
                          return (
                            <TableRow key={index}>
                              {!product.children ? (
                                <TableCell component="th" scope="row">
                                  {row.shop && row.shop.name}
                                </TableCell>
                              ) : null}
                              <TableCell component="th" scope="row">
                                {row.name}
                              </TableCell>
                              <TableCell>{this.renderValue(row)}</TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </Paper>
                </React.Fragment>
              )}
            </DialogContent>
            <DialogActions>
              <div className="container-form-bulk-update-buttons">
                <Button className="button-white-and-red" onClick={this.closeModal}>
                  <span className="button-text">Cancel</span>
                </Button>
                <Button
                  className="button-blue-and-white"
                  variant="contained"
                  onClick={this.beforeUpdateProduct}
                >
                  <span className="button-text">Save</span>
                </Button>
              </div>
            </DialogActions>
          </Dialog>
        ) : (
          <Dialog
            open={open}
            onClose={this.closeModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Bulk Update</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Select master products
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeModal} className="button-blue-and-white" autoFocus>
                <span className="button-text">Accept</span>
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    )
  }
}

const ModalUpdateMasterProductWithTitle = ContainerWithTitle(
  ModalUpdateMasterProduct,
  'Master Products',
)

const ModalUpdateMasterProductConnected = connect(({ dispatch, masterCatalogReducer }) => ({
  dispatch,
  masterCatalogReducer,
}))(ModalUpdateMasterProductWithTitle)

export default ModalUpdateMasterProductConnected



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/ModalUpdateMasterProduct.js